import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { SM_CONSTANTS } from '../../constants/sm-constants';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { ApiService } from 'src/app/providers/api.service';
import { Subscription } from 'rxjs';
import { CustomConfirmDialogComponent } from '../custom-confirm-dialog/custom-confirm-dialog.component';
import { StorageService } from 'src/app/providers/storage.service';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/providers/alert.service';
import { AuthService } from 'src/app/providers/auth.service';

@Component({
  selector: 'sm-deactivate-account',
  templateUrl: './deactivate-account.component.html',
  styleUrls: ['./deactivate-account.component.scss']
})
export class DeactivateAccountComponent implements OnInit {
  message:any=''
  private _apiSubscription: Subscription;
  constructor(@Inject(MAT_DIALOG_DATA) public parentData: any, private loaderservice: LoaderServiceService, private _apiservice: ApiService, private _modelRef: MatDialog, private _storageService: StorageService, private _router: Router, private _alertService: AlertService, private authservice: AuthService) { 

    this._apiSubscription = this._apiservice.apiResult.subscribe(resData => {
      if (resData.responseType === SM_CONSTANTS.RESULT_API_SET_REQUEST) {
        console.log(resData);
        if(resData.result){
          this.parentData.ref.closeAll()
          this._alertService.onOpenSnackbar('Account de-activated successfully.', 3000, 'Ok');
          this.authservice.onSignOut()
        }
      }
    })
  }

  ngOnInit(): void {
  }

  deactivate(){
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
      width: "600px",
      data : {
        title : 'Alert',
        message : 'You will be automatically logged out from this account. For activation you can login again.',
        okbtn : 'Ok',
        cancelbtn : 'Cancel',
        type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
      },
      disableClose : true
    });
    dialogRef.afterClosed().subscribe((result:any)=>{
      console.log(result);
      if(result){ 
        let data = { 
          requestInfo: {
            requestType:1,
            message: this.message,
            note:null,
            requestToName:null,
            requestPhone: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_PHONE_NUMBER),
            requestStatus: 3,
            categoryType: null
          }
        
        }
    
        this.loaderservice.showLoader = true
        this._apiservice.setRequest(data)
      }
    })

   
    
  }
}
